import { IGuestCandidateApplicationAuth } from "../interfaces/i-guest-candidate-application-auth";

export class GuestApplicationViewAuthFactory {
  static New(): IGuestCandidateApplicationAuth {
    return { applicationId: '', phoneNumber: '' };
  }
}
